import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TabLockService } from '../services/tab-lock.service';

/**
 * Full-screen block shown when WizTasks has been opened in another browser tab.
 * Mounted once at the app root.
 */
@Component({
  selector: 'app-tab-lock-overlay',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (tabLock.blocked()) {
      <div
        class="fixed inset-0 z-[300] flex items-center justify-center bg-slate-900/80 backdrop-blur-sm p-4"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="tablock-title"
      >
        <div class="w-full max-w-sm rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-7 text-center shadow-2xl">
          <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 text-amber-600 dark:bg-amber-950/60 dark:text-amber-400">
            <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.55-4.55a1 1 0 011.7.7V17.85a1 1 0 01-1.7.7L15 14M5 8h6a2 2 0 012 2v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4a2 2 0 012-2z" />
            </svg>
          </div>
          <h2 id="tablock-title" class="mt-4 text-lg font-semibold text-slate-900 dark:text-white">
            WizTasks is open in another tab
          </h2>
          <p class="mt-2 text-sm text-slate-600 dark:text-slate-300">
            For your security, WizTasks runs in a single tab at a time. This tab has been paused because you
            opened WizTasks somewhere else.
          </p>
          <button
            type="button"
            (click)="tabLock.takeOver()"
            class="mt-6 w-full rounded-xl bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white shadow-md hover:bg-blue-500 transition-colors"
          >
            Use WizTasks in this tab
          </button>
        </div>
      </div>
    }
  `,
})
export class TabLockOverlayComponent {
  tabLock = inject(TabLockService);
}
